import useInstance from './useInstance'

export default () => {
  const amplitudeInstance = useInstance()
  return amplitudeInstance.logEvent.bind(amplitudeInstance)
}
